import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const container = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
});

export const countdownWrapper = style({
  lineHeight: 1.2,
  fontFamily: vars.fonts.bold,
  fontSize: "4rem",
});
